var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: true, loading: _vm.loading } },
    [
      _c("InformationWrapper", {
        scopedSlots: _vm._u(
          [
            {
              key: "primary",
              fn: function () {
                return [
                  _c(
                    "InformationCard",
                    { attrs: { title: "Background" } },
                    [
                      _vm.showDiscalimer && !_vm.loading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mb-6 flex warningText flex-row justify-between w-full",
                            },
                            [
                              _c("div", { staticClass: "flex flex-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mt-1 h-4 w-auto",
                                    attrs: { alt: "delete notes" },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "Icon / InfoCircleFilled",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                id: "Vector",
                                                d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                                fill: "#070823",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "child ml-2" }, [
                                  _vm._v(
                                    " Upload Resource resume to quickly add skills and profile data for your admin view. "
                                  ),
                                ]),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cursor-pointer flex items-center justify-center",
                                  on: {
                                    click: function ($event) {
                                      _vm.showDiscalimer = false
                                    },
                                    mouseover: function ($event) {
                                      _vm.isHovered = true
                                    },
                                    mouseout: function ($event) {
                                      _vm.isHovered = false
                                    },
                                  },
                                },
                                [
                                  !_vm.isHovered
                                    ? _c("CrossIcon", {
                                        staticClass: "h-3.5 w-3.5",
                                      })
                                    : _vm._e(),
                                  _vm.isHovered
                                    ? _c("CrossIconHover", {
                                        staticClass: "close-icon",
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "flex justify-end mb-8" },
                        [
                          _c("UIButton", {
                            staticClass: "mx-2",
                            attrs: {
                              buttonText: "Upload resume",
                              variant: "outline-black",
                              buttonClasses: "px-2 pr-4 pl-4",
                              size: "md",
                            },
                            on: { click: _vm.openModal },
                            scopedSlots: _vm._u([
                              {
                                key: "icon",
                                fn: function () {
                                  return [
                                    _c("DownloadIcon", {
                                      staticClass: "w-4 h-4",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "hover-icon",
                                fn: function () {
                                  return [
                                    _c("DownloadIcon", {
                                      staticClass: "w-4 h-4",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm.showResume
                        ? _c("AddResumeModal", {
                            attrs: {
                              userId: _vm.currentUserId,
                              contractorId: _vm.contractorId,
                              contractorUserId: _vm.contractorUserId,
                            },
                            on: {
                              close: _vm.closeModal,
                              refetchResource: () => {
                                _vm.$emit("refreshContractor")
                              },
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1 w-full",
                              attrs: {
                                label: "Skills",
                                wide: "",
                                totalNumber: _vm.skills2?.length,
                              },
                            },
                            [
                              _vm.skills2?.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: { chipWithLinkDatas: _vm.skills2 },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No skills added. ")]
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex-row items-center" },
                            [
                              _c("UiButton", {
                                staticClass: "absolute",
                                class: {
                                  "right-4":
                                    _vm.skills2 && _vm.skills2.length > 0,
                                  "right-auto": _vm.skills2.length === 0,
                                },
                                attrs: {
                                  label:
                                    _vm.skills2?.length > 0
                                      ? `edit`
                                      : `add black`,
                                },
                                on: {
                                  click: () => {
                                    _vm.showManagementAddContractorInfoModal = true
                                    _vm.managementAddedInfoMode.skills = true
                                  },
                                },
                              }),
                              _vm.skills2?.length > 0
                                ? _c("UiButton", {
                                    staticClass: "absolute right-0",
                                    attrs: {
                                      label:
                                        _vm.skills2?.length > 0 &&
                                        `delete black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.skills = true
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1 w-full",
                              attrs: {
                                label: "Soft Skills",
                                wide: "",
                                totalNumber: _vm.softSkills2?.length,
                              },
                            },
                            [
                              _vm.softSkills2?.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas: _vm.softSkills2,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No soft skills added. ")]
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex-row items-center" },
                            [
                              _c("UiButton", {
                                staticClass: "absolute",
                                class: {
                                  "right-4":
                                    _vm.softSkills2 &&
                                    _vm.softSkills2.length > 0,
                                  "right-auto": _vm.softSkills2.length === 0,
                                },
                                attrs: {
                                  label:
                                    _vm.softSkills2?.length > 0
                                      ? `edit`
                                      : `add black`,
                                },
                                on: {
                                  click: () => {
                                    _vm.showManagementAddContractorInfoModal = true
                                    _vm.managementAddedInfoMode.softSkills = true
                                  },
                                },
                              }),
                              _vm.softSkills2?.length > 0
                                ? _c("UiButton", {
                                    staticClass: "absolute right-0",
                                    attrs: {
                                      label:
                                        _vm.softSkills2?.length > 0 &&
                                        `delete black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.softSkills = true
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                label: "Industries",
                                wide: "",
                                totalNumber: _vm.industries2?.length,
                              },
                            },
                            [
                              _vm.industries2.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas: _vm.industries2,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No industries added. ")]
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex-row items-center" },
                            [
                              _c("UiButton", {
                                staticClass: "absolute",
                                class: {
                                  "right-4":
                                    _vm.industries2 &&
                                    _vm.industries2.length > 0,
                                  "right-auto": _vm.industries2.length === 0,
                                },
                                attrs: {
                                  label:
                                    _vm.industries2?.length > 0
                                      ? `edit`
                                      : `add black`,
                                },
                                on: {
                                  click: () => {
                                    _vm.showManagementAddContractorInfoModal = true
                                    _vm.managementAddedInfoMode.industries = true
                                  },
                                },
                              }),
                              _vm.industries2?.length > 0
                                ? _c("UiButton", {
                                    staticClass: "absolute right-0",
                                    attrs: {
                                      label:
                                        _vm.industries2?.length > 0 &&
                                        `delete black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.industries = true
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                label: "Languages",
                                wide: "",
                                totalNumber:
                                  _vm.languagesWithProficiency?.length,
                              },
                            },
                            [
                              _vm.languagesWithProficiency.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas:
                                        _vm.languagesWithProficiency,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No languages added. ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                label: "Transportation",
                                wide: "",
                                totalNumber: _vm.transportationTypes?.length,
                              },
                            },
                            [
                              _vm.transportationTypes.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas:
                                        _vm.transportationTypes,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No transportation types added. ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col justify-between items-start w-full mb-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row w-full relative justify-between items-start",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v("Previous Work"),
                                  _c(
                                    "span",
                                    { staticClass: "totalNumber ml-0.5" },
                                    [_vm._v(_vm._s(_vm.getWorkCount))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.workSamples !== null
                            ? _c("Slider", {
                                attrs: { items: _vm.workSamples },
                              })
                            : _vm._e(),
                          _vm.workSamplesByManagement?.length > 0
                            ? _c("Slider", {
                                attrs: { items: _vm.workSamplesByManagement },
                              })
                            : _vm._e(),
                          _vm.workSamples === null &&
                          _vm.workSamplesByManagement?.length === 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No previous work added. ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full justify-between items-start",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Experience "),
                                  _vm.experiences?.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.experiences?.length) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex flex-row items-center" },
                                [
                                  _c("UiButton", {
                                    staticClass: "absolute",
                                    class: {
                                      "right-4":
                                        _vm.experiencesByManagement &&
                                        _vm.experiencesByManagement.length > 0,
                                      "right-auto":
                                        _vm.experiencesByManagement.length ===
                                        0,
                                    },
                                    attrs: {
                                      label:
                                        _vm.experiencesByManagement?.length > 0
                                          ? `edit`
                                          : `add black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.experience = true
                                      },
                                    },
                                  }),
                                  _vm.experiencesByManagement?.length > 0
                                    ? _c("UiButton", {
                                        staticClass: "absolute right-0",
                                        attrs: {
                                          label:
                                            _vm.experiencesByManagement
                                              ?.length > 0 && `delete black`,
                                        },
                                        on: {
                                          click: () => {
                                            _vm.showManagementAddContractorInfoModal = true
                                            _vm.managementAddedInfoMode.experience = true
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm.experiences?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full mb-10" },
                                _vm._l(_vm.experiences, function (experience) {
                                  return _c("ExperienceCard", {
                                    key: experience.id,
                                    staticClass: "card",
                                    attrs: {
                                      jobTitle: experience.job_title,
                                      companyName: experience.company_name,
                                      industry: experience.industry,
                                      skills: experience.skills,
                                      summary: experience.summary,
                                      isAddedBy: experience.added_by_id,
                                      employmentType:
                                        experience.employment_type,
                                      location: experience.location,
                                      startDate: experience.start_date,
                                      endDate: experience.end_date,
                                    },
                                  })
                                }),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new mb-10",
                                },
                                [_vm._v(" No experience added. ")]
                              ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Education "),
                                  _vm.educations?.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.educations?.length) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex flex-row items-center" },
                                [
                                  _c("UiButton", {
                                    staticClass: "absolute",
                                    class: {
                                      "right-4":
                                        _vm.educationsByManagement &&
                                        _vm.educationsByManagement.length > 0,
                                      "right-auto":
                                        _vm.educationsByManagement.length === 0,
                                    },
                                    attrs: {
                                      label:
                                        _vm.educationsByManagement?.length > 0
                                          ? `edit`
                                          : `add black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.education = true
                                      },
                                    },
                                  }),
                                  _vm.educationsByManagement?.length > 0
                                    ? _c("UiButton", {
                                        staticClass: "absolute right-0",
                                        attrs: {
                                          label:
                                            _vm.educationsByManagement?.length >
                                              0 && `delete black`,
                                        },
                                        on: {
                                          click: () => {
                                            _vm.showManagementAddContractorInfoModal = true
                                            _vm.managementAddedInfoMode.education = true
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm.educations?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full" },
                                _vm._l(_vm.educations, function (education) {
                                  return _c("EducationCard", {
                                    key: education.id,
                                    staticClass: "card mb-10",
                                    attrs: {
                                      title: education.title,
                                      institution: education.institution,
                                      summary: education.summary,
                                      startDate: education.start_date,
                                      isAddedBy: education.added_by_id,
                                      endDate: education.end_date,
                                    },
                                  })
                                }),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No education added. ")]
                              ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full relative justify-between items-start mt-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Certification "),
                                  _vm.certifications.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.certifications?.length
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex flex-row items-center" },
                                [
                                  _c("UiButton", {
                                    staticClass: "absolute",
                                    class: {
                                      "right-4":
                                        _vm.certificationsByManagement &&
                                        _vm.certificationsByManagement.length >
                                          0,
                                      "right-auto":
                                        _vm.certificationsByManagement
                                          .length === 0,
                                    },
                                    attrs: {
                                      label:
                                        _vm.certificationsByManagement?.length >
                                        0
                                          ? `edit`
                                          : `add black`,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.showManagementAddContractorInfoModal = true
                                        _vm.managementAddedInfoMode.certification = true
                                      },
                                    },
                                  }),
                                  _vm.certificationsByManagement?.length > 0
                                    ? _c("UiButton", {
                                        staticClass: "absolute right-0",
                                        attrs: {
                                          label:
                                            _vm.certificationsByManagement
                                              ?.length > 0 && `delete black`,
                                        },
                                        on: {
                                          click: () => {
                                            _vm.showManagementAddContractorInfoModal = true
                                            _vm.managementAddedInfoMode.certification = true
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm.certifications?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full" },
                                _vm._l(
                                  _vm.certifications,
                                  function (certification) {
                                    return _c("CertificationCard", {
                                      key: certification.id,
                                      staticClass: "card mb-10",
                                      attrs: {
                                        title: certification.title,
                                        institution: certification.institution,
                                        startDate: certification.start_date,
                                        isAddedBy: certification.added_by_id,
                                        endDate: certification.end_date,
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No certifications added. ")]
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.showManagementAddContractorInfoModal
                    ? _c("ManagementAddContractorInfo", {
                        attrs: {
                          managementAddedInfoMode: _vm.managementAddedInfoMode,
                          userId: _vm.contractorUserId,
                          profileByManagement: _vm.userProfile,
                          workSamplesByManagement: _vm.workSamplesByManagement,
                          experiencesByManagement:
                            _vm.experiencesByManagement.filter((experience) => {
                              if (experience.added_by_id === _vm.currentUserId)
                                return experience
                            }),
                          educationsByManagement:
                            _vm.educationsByManagement.filter((education) => {
                              if (education.added_by_id === _vm.currentUserId)
                                return education
                            }),
                          certificationsByManagement:
                            _vm.certificationsByManagement.filter(
                              (certification) => {
                                if (
                                  certification.added_by_id ===
                                  _vm.currentUserId
                                )
                                  return certification
                              }
                            ),
                        },
                        on: {
                          close: () => {
                            _vm.showManagementAddContractorInfoModal = false
                            Object.assign(
                              _vm.managementAddedInfoMode,
                              _vm.managementAddedInfoModeInit
                            )
                          },
                          refreshContractor: () => {
                            _vm.$emit("refreshContractor")
                          },
                          refetchProfileByManagement: () => {
                            _vm.processing = true
                            _vm.$apollo.queries.userProfile.refetch()
                            _vm.processing = false
                          },
                        },
                      })
                    : _vm._e(),
                  _c(
                    "InformationEmptyAboutCard",
                    [
                      _vm.resourceCard.length < 1
                        ? _c("div", { staticClass: "w-full" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "flex font-400 labelWidth text-left leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                              },
                              [
                                _vm._v(" Resource Information "),
                                _vm.resourceCard.length > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "totalNumber ml-0.5" },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.resourceCard?.length) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "w-full flex justify-center" },
                              [
                                _c("EmptyResourceInformationPlaceholder", {
                                  attrs: {
                                    description:
                                      "Start adding resource information",
                                    desc: "",
                                    contractorId: _vm.contractorId,
                                    currentUserId: _vm.currentUserId,
                                    isAccessGranted: _vm.isAccessGranted,
                                  },
                                  on: {
                                    open: _vm.showModal,
                                    refresh: _vm.refreshPage,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "image",
                                        fn: function () {
                                          return [_c("EmptyListImageDocuments")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2273432899
                                  ),
                                }),
                              ],
                              1
                            ),
                          ])
                        : _c("ResourceDataTable", {
                            attrs: {
                              currentUserId: _vm.currentUserId,
                              resourceCard: _vm.resourceCard,
                              contractorId: _vm.contractorId,
                              title: "Resource Information",
                              total: _vm.resourceCard?.length,
                            },
                            on: {
                              open: _vm.showModal,
                              refresh: _vm.refreshPage,
                            },
                          }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "secondary",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _vm._t("startSecondaryList", null, {
                        secondaryItemClasses: _vm.secondaryItemClasses,
                      }),
                      _c(
                        "CardBodyItem",
                        {
                          staticClass: "border-b-1",
                          class: _vm.secondaryItemClasses,
                          attrs: { label: "Website" },
                        },
                        [
                          _c("NewTabLink", {
                            staticClass: "truncate",
                            attrs: { url: _vm.profile.website },
                          }),
                        ],
                        1
                      ),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Company",
                          content: _vm.profile.company_name,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Job Title",
                          content: _vm.profile.job_title,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Rate",
                          content: _vm.contractorRates,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Country",
                          content: _vm.profile.country,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: _vm.stateProvinceLabel,
                          content: _vm.profile.state,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "City",
                          content: _vm.profile.city,
                          highlightContent: "",
                        },
                      }),
                      _vm._t("endSecondaryList", null, {
                        secondaryItemClasses: _vm.secondaryItemClasses,
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    [
                      _c("DownloadResume", {
                        attrs: { resumeName: _vm.profile.resume },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }